module.exports = __webpack_public_path__ + "static/img/chu3.e81d75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chu3.jpg
// module id = uoTp
// module chunks = 1